<mat-card>
    <mat-card-content>
        <form [formGroup]="formGroup" (submit)="submit()">
            <div class="group flex">
                <div class="full">
                    <h1>Add Item to Box</h1>
                </div>

                <mat-form-field class="full">
                    <mat-label>Item</mat-label>
                    <mat-select formControlName="item">
                        <mat-option>
                            <ngx-mat-select-search [formControl]="itemSearch" [placeholderLabel]="'Search'"
                                [clearSearchInput]="true" [noEntriesFoundLabel]="'nothing found'">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option [value]="null">
                            None
                        </mat-option>
                        <mat-option *ngFor="let item of filteredItems" [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="full padding-10" *ngIf="inventoriesFiltered && inventoriesFiltered.length"
                    style="max-height: 800px; overflow: auto">
                    <h2>Inventory in stock:</h2>
                    <mat-form-field class="full">
                        <mat-label>Search</mat-label>
                        <input matInput [formControl]="inventoriesSearch">
                    </mat-form-field>
                    <section>
                        <mat-card *ngFor="let inventory of inventoriesFiltered" class="tile mat-elevation-z5 margin-bottom-10">

                            <mat-card-header>
                                <span *ngIf="inventory.configurations">
                                    | Conf: {{ inventory.configurations }}
                                </span>
                            </mat-card-header>

                            <div class="flex row padding-top-10">
                                <div class="min">
                                    <mat-checkbox [checked]="inventories_ids.includes(inventory.id)"
                                    (change)="toggleSelection(inventory.id, $event)">
                                    </mat-checkbox>
                                </div>
                                <div class="max flex row">

                                    <div class="half">
                                        Serial: {{ inventory.serial ? inventory.serial : "---" }}
                                    </div>
                                    <div class="half">
                                        Qty: {{ inventory.quantity }}
                                    </div>
                                    <div class="third">
                                        Lot:
                                        {{ inventory.lot ? inventory.lot : "---" }}
                                    </div>
                                    <div class="third">
                                        Batch: {{ inventory.batch ? inventory.batch : "---" }}
                                    </div>
                                    <div class="third">
                                        Revision:
                                        {{ inventory.rev ? inventory.rev : "---" }}
                                    </div>
                                </div>
                            </div>
                            <mat-divider></mat-divider>
                        </mat-card>
                    </section>
                </div>
            </div>

            <div class="actions">
                <button mat-raised-button type="submit" color="primary" [disabled]="!formGroup.valid">
                    Add
                </button>
                <button mat-raised-button type="button" (click)="close()">
                    Cancel
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>